import { render, staticRenderFns } from "./OrderRating.vue?vue&type=template&id=2be0992c&"
import script from "./OrderRating.vue?vue&type=script&lang=js&"
export * from "./OrderRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports